import locale from './locale';
import RouteBreadcrumbView from './view';
import { LOCALE_KEY } from './const';
import { registerLocale } from '@/shared/helpers/language';
import { useTranslation } from 'react-i18next';

const RouteBreadcrumb = () => {
    const { i18n } = useTranslation(LOCALE_KEY);

    const title = 'RouteBreadcrumb';

    registerLocale(i18n, LOCALE_KEY, locale);

    return <RouteBreadcrumbView {...{ title }} />;
};

export default RouteBreadcrumb;
